export default __webpack_public_path__ + "alberta-fab-change-document.72c23dfca29677490fff.svg";